_ = require('lodash')

integers = [].concat(
  _.map [6..1], (i) ->
    text: "+#{i}"
    value: -i
,
  [text: "0", value: 0]
,
  [text: "-", value: null]
,
  _.map [1..40], (i) ->
    text: "#{i}"
    value: i
)

floats = [].concat(
  [text: "-", value: null]
,
  _.map [0..9], (i) ->
    text: i
    value: ".#{i}"
)

HdcpService = ->
  getAvailableHdcpList: ->
    integers: integers
    floats: floats

  getHdcpObject: (value) ->
    hdcp = {}
    _val = value || null
    _val = 0 if value is 0
    if _val == null
      hdcp.integer = hdcp.float = null
    else
      hdcp.integer = if value >= 0 then Math.floor(value) else Math.ceil(value)
      _float = value.toString().split('.')[1]
      hdcp.float = '.' + if _float then _float else 0
    hdcp

  getHdcpValue: (_int, _float) ->
    int_item = _.find integers, (i) ->
      i.value is _int

    float_item = _.find floats, (f) ->
      f.value is _float

    if int_item == undefined || float_item == undefined || int_item.value == null || float_item.value == null
      null
    else
      int_item.value + float_item.value

module.exports = HdcpService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/hdcp/hdcp-service.coffee